import { router } from 'expo-router';

import { FavoriteItem } from '@/api/models/favoritesModels';
import { bs_icon } from '@/assets/images';
import { firebaseImage } from '@/utils/firebaseImage';

export const extractFavoriteDataItem = (item: FavoriteItem) => {
  const program = item.programs[0] || null;
  const npo = item.npos[0] || null;
  const trendingPost = item.trendingPosts[0] || null;
  const volunteer = item.volunteers[0] || null;
  const mission = item.missions[0] || null;

  let title, image, onPress;

  if (program) {
    title = program.name;
    const firstThumb = JSON.parse(program.thumbnail ?? '');
    image = program.thumbnail ? firebaseImage(firstThumb[0]) : bs_icon;
    // onPress = () =>
    //   router.navigate({
    //     pathname: '/programDetail/[programId]',
    //     params: {
    //       programId: program.id
    //     }
    //   });
  } else if (npo) {
    title = npo.name;
    const firstThumb = JSON.parse(npo.thumbnail);
    image = npo.thumbnail ? firebaseImage(firstThumb[0]) : bs_icon;
    onPress = () =>
      router.navigate({
        pathname: '/npoDetail/[npoId]/insights',
        params: {
          npoId: npo.id
        }
      });
  } else if (trendingPost) {
    title = trendingPost.title;
    const firstThumb = JSON.parse(trendingPost.thumbnail);
    image = trendingPost.thumbnail ? firebaseImage(firstThumb[0]) : bs_icon;
    onPress = () =>
      router.navigate({
        pathname: '/trendingDetail/[trendingId]',
        params: {
          trendingId: trendingPost.id,
          trendingJson: JSON.stringify(trendingPost)
        }
      });
  } else if (volunteer) {
    title = volunteer.name;
    const firstThumb = JSON.parse(volunteer.thumbnail);
    image = volunteer.thumbnail ? firebaseImage(firstThumb[0]) : bs_icon;
    onPress = () =>
      router.navigate({
        pathname: '/volunteerDetail/[volunteerId]',
        params: { volunteerId: volunteer.id }
      });
  } else if (mission) {
    title = mission.name;
    image = mission.thumbnail ? firebaseImage(mission.thumbnail[0]) : bs_icon;
    onPress = () =>
      router.navigate({
        pathname: '/missionDetail/[missionId]',
        params: { missionId: mission.id }
      });
  } else return null;

  return { title, image, onPress };
};
